import React, { useEffect, useState } from 'react';
import { Tabs, Card, Typography, Space } from 'antd';
import { useLocation } from 'react-router-dom';
import { DollarCircleOutlined } from '@ant-design/icons';
import MyClaimsList from './pages/MyClaimsList';
import ClaimApprovalList from './pages/ClaimApprovalList';
import ClaimPaymentList from './pages/ClaimPaymentList';
import ClaimMasterData from './pages/ClaimMasterData';
import { getUser } from 'utils/auth';

const { TabPane } = Tabs;
const { Title, Text } = Typography;

export const CostsClaimIndex: React.FC = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('my-claims');

  const user = getUser();
  const permissions: string[] = user?.permissions || [];
  const roles: any[] = user?.roles || [];
  const roleNames = roles.map((r: any) => (r.name || '').toLowerCase());

  const isSystemAdmin =
    user?.isSystemAdmin ||
    roleNames.some((r) => r.includes('system admin') || r.includes('super-admin'));

  const isLineManager = Boolean(user?.isLineManager);

  // Staff role check: If user's role is Staff and not Admin/Line Manager, strictly hide management tabs
  const isStaffRole = roles.length > 0 && roles.every((r: any) => r.name === 'Staff' || r.id === 6);
  const isStaffOnly = !isSystemAdmin && !isLineManager && isStaffRole;

  const canViewApprovals =
    !isStaffOnly &&
    (isSystemAdmin ||
      isLineManager ||
      permissions.includes('CLAIM_APPROVE_L1') ||
      permissions.includes('CLAIM_APPROVE_L2') ||
      permissions.includes('CLAIM_VIEW_ALL'));

  const canViewPayments =
    !isStaffOnly &&
    (isSystemAdmin ||
      permissions.includes('CLAIM_MARK_PAID') ||
      permissions.includes('CLAIM_VIEW_ALL'));

  const canManageMaster =
    !isStaffOnly && (isSystemAdmin || permissions.includes('CLAIM_MANAGE_MASTER'));

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    if (tabParam) {
      setActiveTab(tabParam);
    }
  }, [location.search]);

  return (
    <div style={{ padding: '20px', background: '#f5f7fa', minHeight: 'calc(100vh - 64px)' }}>
      <Card style={{ marginBottom: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <Space size="middle" align="center">
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 8,
              background: '#e6f7ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <DollarCircleOutlined style={{ fontSize: 24, color: '#1890ff' }} />
          </div>
          <div>
            <Title level={4} style={{ margin: 0 }}>
              Quản lý Chi Phí & Hoàn Ứng (Costs Claim)
            </Title>
            <Text type="secondary">
              Quản lý danh sách yêu cầu thanh toán chi phí, quy trình phê duyệt nhiều cấp và thanh
              toán giải ngân Kế toán
            </Text>
          </div>
        </Space>
      </Card>

      <Tabs
        activeKey={activeTab}
        onChange={(k) => setActiveTab(k)}
        type="card"
        style={{ background: '#fff', padding: '16px', borderRadius: 8 }}
      >
        <TabPane tab="Claim của Tôi" key="my-claims">
          <MyClaimsList />
        </TabPane>

        {canViewApprovals && (
          <TabPane tab="Duyệt Yêu cầu" key="approvals">
            <ClaimApprovalList />
          </TabPane>
        )}

        {canViewPayments && (
          <TabPane tab="Thanh toán (Finance)" key="payments">
            <ClaimPaymentList />
          </TabPane>
        )}

        {canManageMaster && (
          <TabPane tab="Quản lý Danh mục" key="master-data">
            <ClaimMasterData />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default CostsClaimIndex;
